import { API_BASE_URL, LOCAL_STORAGE_KEYS, APP_NAME } from '../constants';
import { redirect } from "react-router-dom";

const request = async (options) => {
    const headers = options.headers || {};

    if (localStorage.getItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN)) {
        headers['Authorization'] = 'Bearer ' + localStorage.getItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN);
    }

    if (APP_NAME) {
        headers['App-Name'] = APP_NAME;
    }

    const fetchOptions = {
        method: options.method,
        headers: headers,
    };

    if (options.body) {
        fetchOptions.body = options.body;
    }

    return fetch(options.url, fetchOptions)
        .then(response =>
            response.json().then(json => {
                if (!response.ok) {
                    json = Object.assign({}, { status: response.status }, json);
                    return Promise.reject(json);
                }
                return json;
            })
        );
};


// utils/APIUtils.js
export function handleLogout() {
  localStorage.removeItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN);
  localStorage.removeItem(LOCAL_STORAGE_KEYS.CURRENT_USER);
  // rediriger vers la vraie route de login
  throw redirect("/"); 
}

// export function handleLogout() {
//     localStorage.removeItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN);
//     localStorage.removeItem(LOCAL_STORAGE_KEYS.CURRENT_USER);
//     throw redirect("/login");
// }

export async function exeRequest(relativeUrl, method, data) {
  const isFormData = data instanceof FormData;

  let options = {
    url: API_BASE_URL + relativeUrl,
    method: method,
    headers: {},
  };

  if (!isFormData) {
    options.headers['Content-Type'] = 'application/json';
    if (data && Object.keys(data).length > 0) {
      options.body = JSON.stringify(data);
    }
  } else {
    options.body = data; // FormData : on met tel quel
  }

  try {
    return await request(options);
  } catch (error) {
    if (error.status === 401) {
      handleLogout();
    } else if (error.status === 403) {
      // alert("Vous n'avez pas les autorisations necessaire pour effectuer cette opération.");
    } else {
      console.error("Erreur API:", error);
      throw error;
    }
  }
}


// export async function exeRequest(relativeUrl, method, data) {
//     let options = {
//         url: API_BASE_URL + relativeUrl,
//         method: method,
//         headers: { 'Content-Type': 'application/json' },
//     };

//     if (data && Object.keys(data).length > 0) {
//         options.body = JSON.stringify(data);
//     }

//     try {
//         return await request(options);
//     } catch (error) {
//         if (error.status === 401) {
//             handleLogout();
//         } else if (error.status === 403) {
//             alert("Vous n'avez pas les autorisations necessaire pour effectuer cette opération.");
//         } else {
//             console.error("Erreur API:", error);
//             throw error;
//         }
//     }
// }